import { cn } from "@/utils";
import { Chip, Tooltip } from "@heroui/react";
import dayjs from "dayjs";

const MonthDayBlock = ({
  date,
  onDateClick,
  gap = "0px",
  disableOnHolidays,
  isHoliday,
  ...props
}: {
  date: string;
  onDateClick: () => void;
  gap?: string;
  disableOnHolidays?: boolean;
  isHoliday?: string;
  children: React.ReactNode;
}) => {
  const dateObject = dayjs(date);
  const dayNumber = dateObject.date();
  const isToday = dateObject.isSame(dayjs(), "day");

  return (
    <div
      className={cn(
        "flex h-40 flex-col overflow-hidden border border-gray-200 px-[1px] py-1 md:px-1",
        {
          "bg-[repeating-linear-gradient(159.5deg,transparent,transparent_8px,#f3f4f7_8px,#f3f4f7_18px)]":
            disableOnHolidays,
        },
      )}
    >
      <div className="flex flex-col-reverse justify-between gap-1 md:flex-row md:items-center">
        <button
          type="button"
          onClick={onDateClick}
          className="flex h-5 items-center justify-center rounded-xl p-2 transition-colors hover:bg-[#00000013] md:justify-start"
        >
          <p
            className={cn("text-sm font-semibold text-[#2F2F2F]", {
              "text-[#5a9f6c]": isToday,
            })}
          >
            {dayNumber}
          </p>
        </button>

        {isHoliday && (
          <Tooltip
            content={isHoliday}
            classNames={{
              content: "bg-[#7e96cd] text-[#fafafa]",
              arrow: "bg-[#7e96cd]",
            }}
            showArrow
          >
            <Chip
              size="sm"
              className="text-truncate max-w-[70%] bg-[#7e96cd] text-xs text-[#fafafa]"
            >
              {isHoliday}
            </Chip>
          </Tooltip>
        )}
      </div>
      <div
        className={"flex w-full flex-col overflow-hidden pt-1"}
        style={{
          gap: gap,
        }}
      >
        {props.children}
      </div>
    </div>
  );
};

export default MonthDayBlock;
